import React from 'react';
import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ScrollToTop from 'react-router-scroll-top'
import Home from './../src/container/Home/Home';
import Mens from './../src/container/Category/Mens/Mens';
import Cart from './../src/container/Category/Cart/Cart';
import ProductView from './../src/container/Category/ProductView/ProductView';
import ProductMugView from './../src/container/Category/ProductMugView/ProductMugView';
import AboutUs from './../src/container/AboutUs/AboutUs';
import OurStory from './../src/container/OurStory/OurStory';
import Contacts from './../src/container/Contacts/Contacts';
import Covid19 from './../src/container/Covid-19/Covid19';
import SearchIcon from './../src/component/SearchIcon/SearchIcon';
import Checkout from './../src/container/Checkout/Checkout';
import CheckoutShippingAddress from './../src/container/CheckoutShippingAddress/CheckoutShippingAddress';
import ProductCustomize from './container/Category/ProductCustomize/ProductCustomize';
import ProductCupCustomize from './container/Category/ProductCupCustomize/ProductCupCustomize';
import ProductKeyCustomize from './container/Category/ProductKeyCustomize/ProductKeyCustomize';
import ProductMobileCustomize from './container/Category/ProductMobileCustomize/ProductMobileCustomize';
import OrderHistory from './container/OrderHistory/OrderHistory';
import ProfileDetails from './container/ProfileDetails/ProfileDetails';
import ProfileUpdate from './container/ProfileUpdate/ProfileUpdate';
import ChangePassword from './container/ChangePassword/ChangePassword';
import ForgetPassword from './container/ForgetPassword/ForgetPassword';
import VerifyForgotPassword from './container/VerifyForgotPassword/VerifyForgotPassword';
import OrderDetails from './container/OrderDetails/OrderDetails';
import ProductWomenCustomize from './container/Category/ProductWomenCustomize/ProductWomenCustomize';
import ProductKidsCustomize from './container/Category/ProductKidsCustomize/ProductKidsCustomize';
import MenuSubCategory from './container/MenuSubCategory/MenuSubCategory';
import TermsAndConditions from './container/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './container/PrivacyPolicy/PrivacyPolicy';
import RefundsReturns from './container/Refunds&Returns/RefundsReturns';
import FAQ from './container/FAQ/FAQ';
import OrderTracking from './container/OrderTracking/OrderTracking';
import ProductComboCustomize from './container/Category/ProductComboCustomize/ProductComboCustomize';
import ProductCoupleCombo from './container/Category/ProductCoupleCombo/ProductCoupleCombo';
import TipsOnDesigningTees from './container/TipsOnDesigningTees/TipsOnDesigningTees';
import TipsOnDesigningMugs from './container/TipsOnDesigningMugs/TipsOnDesigningMugs';
import TipsOnDesigningMobileCover from './container/TipsOnDesigningMobileCover/TipsOnDesigningMobileCover';
import NotFound from './container/NotFound/NotFound';
import CorporateDeals from './container/CorporateDeals/CorporateDeals';
import MyWallet from './container/MyWallet/MyWallet';
import CorporateTab from './container/Corporate/CorporateTab/CorporateTab';
import CorporateShippingAddress from './container/Corporate/CorporateShippingAddress/CorporateShippingAddress';
import CorporateProductCustomize from './container/Corporate/CorporateProductCustomize/CorporateProductCustomize';


import CorporateProductView from './container/Corporate/CorporateProductView/CorporateProductView';
import CorporateProductCart from './container/Corporate/CorporateProductCart/CorporateProductCart';

import CorporateCheckOut from './container/Corporate/CorporateCheckout/CorporateCheckout';
import CorporateOrderHistory from './container/CorporateOrderHistory/CorporateOrderHistory';
import CorporateProductCustomizeView from './container/Corporate/CorporateProductCustomizeView/CorporateProductCustomizeView';
import CorporateOrderDetails from './container/CorporateOrderDetails/CorporateOrderDetails';
import AddressList from './container/AddressList/AddressList';
// import firebase  from './firebase';

function App() {
  // const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari']);



  React.useEffect(() => {
    // if(isSafari){ 

    //   localStorage.setItem('device_token', null);
    // }else{
    //   const msg=firebase.messaging();
    //   msg.requestPermission().then(function(){
    //     return msg.getToken();
    //   }).then(function(data){
    //     // console.warn("token",data)

    //     localStorage.setItem('device_token', data);
    //   })
    //   .catch(function(err){
    //     console.log(err)
    //   })
    // }      
  })


  // render() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <ScrollToTop>

          <Switch>
            <Route exact={true} path='/' component={Home} />
            <Route path='/product/:catid/:subid/:slug' component={Mens} />
            <Route path='/productcustomize/:catid/:subid/:slug' component={ProductCustomize} />
            <Route path='/productmobilecustomize/:catid/:subid/:slug' component={ProductMobileCustomize} />
            <Route path='/productwomencustomize/:catid/:subid/:slug' component={ProductWomenCustomize} />
            <Route path='/productkidscustomize/:catid/:subid/:slug' component={ProductKidsCustomize} />

            <Route path='/productview/:id/:slug' component={ProductView} />
            <Route path='/product-mug-view/:id/:slug' component={ProductMugView} />
            <Route path='/productcupcustomize/:id/:slug' component={ProductCupCustomize} />
            <Route path='/productkeycustomize/:id/:slug' component={ProductKeyCustomize} />
            <Route path='/productcombocustomize/:id/:slug' component={ProductComboCustomize} />
            <Route path='/productcouplecombo/:id/:slug' component={ProductCoupleCombo} />

            <Route path='/menu-subcatrgory/:id/:slug' component={MenuSubCategory} />

            <Route path='/cart' component={Cart} />
            <Route path='/aboutus' component={AboutUs} />
            <Route path='/ourstory' component={OurStory} />
            <Route path='/contacts' component={Contacts} />
            <Route path='/covid19' component={Covid19} />
            <Route path='/searchicon' component={SearchIcon} />
            <Route path='/checkout' component={Checkout} />
            <Route path='/checkoutshippingaddress' component={CheckoutShippingAddress} />
            <Route path='/order-history' component={OrderHistory} />
            <Route path='/profile-details' component={ProfileDetails} />
            <Route path='/profile-update' component={ProfileUpdate} />
            <Route path='/change-password' component={ChangePassword} />
            <Route path='/my-wallet' component={MyWallet} />
            <Route path='/forgot-password' component={ForgetPassword} />
            <Route path='/verify-forgotpassword' component={VerifyForgotPassword} />
            <Route path='/order-details' component={OrderDetails} />
            <Route path='/corporate-deals' component={CorporateDeals} />

            <Route path='/terms-conditions' component={TermsAndConditions} />
            <Route path='/privacy-policy' component={PrivacyPolicy} />
            <Route path='/refunds-returns' component={RefundsReturns} />
            <Route path='/frequently-asked-questions' component={FAQ} />
            <Route path='/order-tracking' component={OrderTracking} />
            <Route path='/tips-on-designing-tees' component={TipsOnDesigningTees} />
            <Route path='/tips-on-designing-mugs' component={TipsOnDesigningMugs} />
            <Route path='/tips-on-designing-mobilecover' component={TipsOnDesigningMobileCover} />

            <Route path='/corporate-tab' component={CorporateTab} />
            <Route path='/corporate-checkout' component={CorporateCheckOut} />
            <Route path='/corporate-product-cart' component={CorporateProductCart} />
            <Route path='/corporate-address' component={CorporateShippingAddress} />
            <Route path='/corporate-men-customize/:id/:slug' component={CorporateProductCustomize} />
            <Route path='/corporate-customize-view/:id/:slug' component={CorporateProductCustomizeView} />
            <Route path='/corporate-productview/:id/:slug' component={CorporateProductView} />
            <Route path='/corporate-order-details' component={CorporateOrderDetails} />
            <Route path='/corporate-order-history' component={CorporateOrderHistory} />
            <Route path='/address-info' component={AddressList} />
            <Route component={NotFound} />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
    </React.Fragment>
  );
  // }
}

export default App;
